/* Breadcrumb navigation with a house icon for the Home link and muted chevron separators. */

import { Link } from 'react-router-dom';
import { ChevronRight, House } from 'lucide-react';

export interface Crumb {
  label: string;
  href?: string;
}

export default function PageBreadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="breadcrumb" className="mb-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-[12px] tracking-[0.02em] text-[#5a6552] sm:text-[13px]">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="inline-flex items-center gap-1.5">
              {item.href && !isLast ? (
                <Link to={item.href} className="inline-flex items-center gap-1.5 transition-colors hover:text-[#1e2b22]">
                  {index === 0 && <House className="h-3.5 w-3.5" strokeWidth={1.7} aria-hidden="true" />}
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'font-medium text-[#1e2b22]' : ''}>
                  {item.label}
                </span>
              )}
              {!isLast && <ChevronRight className="h-3 w-3 text-[#cfcac2]" strokeWidth={1.6} />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
